import { LocalDateTime } from 'src/main/angular/app/shared/jsr310-localdates/types/local-date-time.type';
import { UpdatePlannedAccesOrder } from './update-planned-acces-order.entity';
import { NotifiableByMailOrder } from './has-id.interface';

export class UpdateAndGrantAccesOrder extends UpdatePlannedAccesOrder implements NotifiableByMailOrder {
	dateAutorisation!: LocalDateTime;
	controleSecurite!: number | null;
	
	forceMailsAsTest?: boolean;

	constructor() {
		super();
	}
}